
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrderUpdateWithType2Response} from './OrderUpdateWithType2Response';
import {OrderUpdate} from './OrderUpdate';
import {FieldModelOrderUpdate} from './OrderUpdate';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';
import {TradeTransactionReason} from '../core/TradeTransactionReason';
import {FieldModelTradeTransactionReason} from '../core/TradeTransactionReason';

/**
 * OrderUpdateWithType2Request struct
 */
class OrderUpdateWithType2Request extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!OrderUpdate=} order
   * @param {string=} newClientOrderId
   * @param {!OrderType=} newType
   * @param {!UUID=} accountGroupId
   * @param {!TradeTransactionReason=} transactionReason
   * @param {string=} externalClientId
   * @param {!number=} newOrderId
   * @constructor
   */
  constructor (parent = new Request(), order = new OrderUpdate(), newClientOrderId = null, newType = new OrderType(), accountGroupId = new UUID(), transactionReason = new TradeTransactionReason(), externalClientId = null, newOrderId = new UInt64(0, 0)) {
    super()
    super.copy(parent)
    this.Order = order
    this.NewClientOrderId = newClientOrderId
    this.NewType = newType
    this.AccountGroupId = accountGroupId
    this.TransactionReason = transactionReason
    this.ExternalClientId = externalClientId
    this.NewOrderId = newOrderId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderUpdateWithType2Request}
   * @param {!OrderUpdateWithType2Request} other Other struct
   * @returns {!OrderUpdateWithType2Request} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Order != null) {
      this.Order = OrderUpdate.fromObject(other.Order)
    } else {
      this.Order = null
    }
    if (other.NewClientOrderId != null) {
      this.NewClientOrderId = other.NewClientOrderId
    } else {
      this.NewClientOrderId = null
    }
    if (other.NewType != null) {
      this.NewType = OrderType.fromObject(other.NewType)
    } else {
      this.NewType = null
    }
    if (other.AccountGroupId != null) {
      this.AccountGroupId = new UUID(other.AccountGroupId)
    } else {
      this.AccountGroupId = null
    }
    if (other.TransactionReason != null) {
      this.TransactionReason = TradeTransactionReason.fromObject(other.TransactionReason)
    } else {
      this.TransactionReason = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.NewOrderId != null) {
      this.NewOrderId = UInt64.fromNumber(other.NewOrderId)
    } else {
      this.NewOrderId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderUpdateWithType2Request}
   * @returns {!OrderUpdateWithType2Request} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderUpdateWithType2RequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderUpdateWithType2RequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderUpdateWithType2Request}
   * @param {!OrderUpdateWithType2Request} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderUpdateWithType2Request)) {
      throw new TypeError('Instance of OrderUpdateWithType2Request is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderUpdateWithType2Request}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Order: ((this.Order != null) ? this.Order : null),
      NewClientOrderId: ((this.NewClientOrderId != null) ? this.NewClientOrderId : null),
      NewType: ((this.NewType != null) ? this.NewType : null),
      AccountGroupId: ((this.AccountGroupId != null) ? this.AccountGroupId.toString() : null),
      TransactionReason: ((this.TransactionReason != null) ? this.TransactionReason : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      NewOrderId: ((this.NewOrderId != null) ? this.NewOrderId.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderUpdateWithType2Request.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderUpdateWithType2Request} other Object value
   * @returns {!OrderUpdateWithType2Request} Created struct
   */
  static fromObject (other) {
    return new OrderUpdateWithType2Request().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderUpdateWithType2Request}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderUpdateWithType2Request.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderUpdateWithType2Request}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4107
  }
}

export { OrderUpdateWithType2Request };

/**
 * Fast Binary Encoding OrderUpdateWithType2Request field model
 */
class FieldModelOrderUpdateWithType2Request extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Order = new FieldModelOrderUpdate(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.NewClientOrderId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Order.fbeOffset + this.Order.fbeSize), buffer, this.Order.fbeOffset + this.Order.fbeSize)
    this.NewType = new FieldModelOrderType(buffer, this.NewClientOrderId.fbeOffset + this.NewClientOrderId.fbeSize)
    this.AccountGroupId = new fbe.FieldModelUUID(buffer, this.NewType.fbeOffset + this.NewType.fbeSize)
    this.TransactionReason = new FieldModelTradeTransactionReason(buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize), buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize)
    this.NewOrderId = new fbe.FieldModelUInt64(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Order.fbeSize + this.NewClientOrderId.fbeSize + this.NewType.fbeSize + this.AccountGroupId.fbeSize + this.TransactionReason.fbeSize + this.ExternalClientId.fbeSize + this.NewOrderId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Order.fbeExtra + this.NewClientOrderId.fbeExtra + this.NewType.fbeExtra + this.AccountGroupId.fbeExtra + this.TransactionReason.fbeExtra + this.ExternalClientId.fbeExtra + this.NewOrderId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderUpdateWithType2Request.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4107
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Order.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.NewClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewType.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionReason.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.NewOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewOrderId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!OrderUpdateWithType2Request} fbeValue Default value, defaults is new OrderUpdateWithType2Request()
   * @returns {!OrderUpdateWithType2Request} OrderUpdateWithType2Request value
   */
  get (fbeValue = new OrderUpdateWithType2Request()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!OrderUpdateWithType2Request} fbeValue OrderUpdateWithType2Request value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) <= fbeStructSize) {
      fbeValue.Order = this.Order.get()
    } else {
      fbeValue.Order = new OrderUpdate()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.NewClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.NewClientOrderId = this.NewClientOrderId.get()
    } else {
      fbeValue.NewClientOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewType.fbeSize) <= fbeStructSize) {
      fbeValue.NewType = this.NewType.get()
    } else {
      fbeValue.NewType = new OrderType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewType.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupId = this.AccountGroupId.get()
    } else {
      fbeValue.AccountGroupId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionReason = this.TransactionReason.get()
    } else {
      fbeValue.TransactionReason = new TradeTransactionReason()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.NewOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.NewOrderId = this.NewOrderId.get()
    } else {
      fbeValue.NewOrderId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewOrderId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {!OrderUpdateWithType2Request} fbeValue OrderUpdateWithType2Request value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderUpdateWithType2Request}
   * @param {OrderUpdateWithType2Request} fbeValue OrderUpdateWithType2Request value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Order.set(fbeValue.Order)
    this.NewClientOrderId.set(fbeValue.NewClientOrderId)
    this.NewType.set(fbeValue.NewType)
    this.AccountGroupId.set(fbeValue.AccountGroupId)
    this.TransactionReason.set(fbeValue.TransactionReason)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.NewOrderId.set(fbeValue.NewOrderId)
  }
}

export { FieldModelOrderUpdateWithType2Request };

/**
 * Fast Binary Encoding OrderUpdateWithType2Request model
 */
class OrderUpdateWithType2RequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderUpdateWithType2Request(this.buffer, 4)
  }

  /**
   * Get the OrderUpdateWithType2Request model
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!FieldModelOrderUpdateWithType2Request} model OrderUpdateWithType2Request model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderUpdateWithType2RequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderUpdateWithType2Request.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderUpdateWithType2RequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderUpdateWithType2RequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderUpdateWithType2RequestModel}
   * @param {!OrderUpdateWithType2Request} value OrderUpdateWithType2Request value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderUpdateWithType2RequestModel}
   * @param {!OrderUpdateWithType2Request} value OrderUpdateWithType2Request value, defaults is new OrderUpdateWithType2Request()
   * @return {!object} Deserialized OrderUpdateWithType2Request value and its size
   */
  deserialize (value = new OrderUpdateWithType2Request()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderUpdateWithType2Request(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderUpdateWithType2Request(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderUpdateWithType2RequestModel}
   * @param {!number} prev Previous OrderUpdateWithType2Request model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderUpdateWithType2RequestModel };
OrderUpdateWithType2Request.__has_response = true;
OrderUpdateWithType2Request.__response_class = OrderUpdateWithType2Response;
